export const config = {
  ENVIRONMENT: process.env.ENVIRONMENT,
  GOOGLE_CLIENT_ID: process.env.GOOGLE_CLIENT_ID,
  GOOGLE_MAP_API_KEY: process.env.GOOGLE_MAP_API_KEY,
  MEMBER_WEBSITE_URL: process.env.MEMBER_WEBSITE_URL,
  ADMIN_WEBSITE_URL: process.env.ADMIN_WEBSITE_URL,
  ATC_WEBSITE_URL: process.env.ATC_WEBSITE_URL,
  CESIUM_ACCESS_TOKEN: process.env.CESIUM_ACCESS_TOKEN
};
